import PropTypes from "prop-types"
import React from "react"

import { Collapsible } from "../Collapsible"
import { useSingleOpen } from "./hooks/useSingleOpen"

/**
 * A list of collapsible items with internal state
 */
export function CollapsibleList({
  items,
  enforceSingleOpen,
  scrollWhenOpen = true,
  className,
  openIcon = "▼",
  closeIcon = "▲",
}) {
  const { getItemOpenProps } = useSingleOpen({
    enforceSingleOpen,
    items,
  })

  return (
    <>
      {items.map((item, index) => {
        const { id, title, content } = item
        const openProps = getItemOpenProps(index)

        return (
          <Collapsible
            key={id || index}
            id={id || `accordion-${index}`}
            title={title}
            scrollWhenOpen={scrollWhenOpen}
            className={className}
            {...openProps}
            openIcon={openIcon}
            closeIcon={closeIcon}
          >
            {content}
          </Collapsible>
        )
      })}
    </>
  )
}

CollapsibleList.propTypes = {
  /**
   * If true only one tab will be open per time
   */
  enforceSingleOpen: PropTypes.bool,
  /**
   * If true the newly opened tab will be scrolled into view
   * @default true
   */
  scrollWhenOpen: PropTypes.bool,
  /**
   * A list of collapsible items
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      content: PropTypes.node,
      id: PropTypes.string,
      initialOpen: PropTypes.bool,
    }),
  ),
  /**
   * Icon to show when the collapsible is CLOSED and needs to be opened
   * @default ▼
   */
  openIcon: PropTypes.node,
  /**
   * Icon to show when the collapsible is OPENED and needs to be closed
   * @default ▲
   */
  closeIcon: PropTypes.node,
}
